import { createRouter, createWebHashHistory } from 'vue-router'

import login from "@/pages/page-login"
import home from "@/pages/page-home"

const routes = [
    // { path: '*', component: home },
    { path: '/', component: home },
    { path: '/login', component: login },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router